import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCog, 
  faSave, 
  faArrowLeft,
  faUpload,
  faPlus,
  faTrash,
  faEye,
  faSpinner,
  faSync,
  faIdCard,
  faGripVertical,
  faFont,
  faExpand,
  faPalette
} from '@fortawesome/free-solid-svg-icons';
import api from '../../services/api';
import credencialConfigService from '../../services/credencialConfigService';

// Campos disponíveis para configurar - AMPLIADO
const CAMPOS_DISPONIVEIS = [
  // Dados do Aluno
  { id: 'nome', label: 'Nome do Aluno', tipo: 'texto', grupo: 'Aluno' },
  { id: 'cpf', label: 'CPF', tipo: 'texto', grupo: 'Aluno' },
  { id: 'identidade', label: 'Identidade (RG)', tipo: 'texto', grupo: 'Aluno' },
  { id: 'dataNascimento', label: 'Data de Nascimento', tipo: 'data', grupo: 'Aluno' },
  { id: 'naturalidade', label: 'Naturalidade', tipo: 'texto', grupo: 'Aluno' },
  { id: 'nacionalidade', label: 'Nacionalidade', tipo: 'texto', grupo: 'Aluno' },
  { id: 'sexo', label: 'Sexo', tipo: 'texto', grupo: 'Aluno' },
  { id: 'email', label: 'E-mail', tipo: 'texto', grupo: 'Aluno' },
  { id: 'telefone', label: 'Telefone', tipo: 'texto', grupo: 'Aluno' },
  { id: 'celular', label: 'Celular', tipo: 'texto', grupo: 'Aluno' },
  
  // Dados da Matrícula
  { id: 'numeroMatricula', label: 'Nº Matrícula', tipo: 'texto', grupo: 'Matrícula' },
  { id: 'dataMatricula', label: 'Data de Matrícula', tipo: 'data', grupo: 'Matrícula' },
  { id: 'dataInicio', label: 'Data de Início', tipo: 'data', grupo: 'Matrícula' },
  { id: 'dataTermino', label: 'Data de Término', tipo: 'data', grupo: 'Matrícula' },
  { id: 'turma', label: 'Turma', tipo: 'texto', grupo: 'Matrícula' },
  { id: 'situacao', label: 'Situação', tipo: 'texto', grupo: 'Matrícula' },
  
  // Dados do Curso
  { id: 'curso', label: 'Nome do Curso', tipo: 'texto', grupo: 'Curso' },
  { id: 'cursoSigla', label: 'Sigla do Curso', tipo: 'texto', grupo: 'Curso' },
  { id: 'cargaHoraria', label: 'Carga Horária', tipo: 'texto', grupo: 'Curso' },
  
  // Dados da Extensão/Igreja
  { id: 'extensao', label: 'Extensão/Igreja', tipo: 'texto', grupo: 'Igreja' },
  { id: 'extensaoSigla', label: 'Sigla da Extensão', tipo: 'texto', grupo: 'Igreja' },
  { id: 'pastor', label: 'Pastor/Líder', tipo: 'texto', grupo: 'Igreja' },
  { id: 'cidade', label: 'Cidade', tipo: 'texto', grupo: 'Igreja' },
  { id: 'uf', label: 'UF', tipo: 'texto', grupo: 'Igreja' },
  
  // Dados Profissionais
  { id: 'funcao', label: 'Função', tipo: 'texto', grupo: 'Profissional' },
  { id: 'cargo', label: 'Cargo', tipo: 'texto', grupo: 'Profissional' },
  { id: 'ministerio', label: 'Ministério', tipo: 'texto', grupo: 'Profissional' },
  
  // Credencial
  { id: 'dataExpedicao', label: 'Data de Expedição', tipo: 'data', grupo: 'Credencial' },
  { id: 'dataValidade', label: 'Data de Validade', tipo: 'data', grupo: 'Credencial' },
  { id: 'registro', label: 'Nº Registro', tipo: 'texto', grupo: 'Credencial' },
  
  // Textos Estáticos (Labels)
  { id: 'labelNome', label: 'Label: "Nome"', tipo: 'label', grupo: 'Labels', textoFixo: 'Nome:' },
  { id: 'labelCPF', label: 'Label: "CPF"', tipo: 'label', grupo: 'Labels', textoFixo: 'CPF:' },
  { id: 'labelRG', label: 'Label: "RG"', tipo: 'label', grupo: 'Labels', textoFixo: 'RG:' },
  { id: 'labelNascimento', label: 'Label: "Nascimento"', tipo: 'label', grupo: 'Labels', textoFixo: 'Nascimento:' },
  { id: 'labelMatricula', label: 'Label: "Matrícula"', tipo: 'label', grupo: 'Labels', textoFixo: 'Matrícula:' },
  { id: 'labelValidade', label: 'Label: "Validade"', tipo: 'label', grupo: 'Labels', textoFixo: 'Validade:' },
  { id: 'labelExpedicao', label: 'Label: "Expedição"', tipo: 'label', grupo: 'Labels', textoFixo: 'Expedição:' },
  { id: 'labelNacionalidade', label: 'Label: "Nacionalidade"', tipo: 'label', grupo: 'Labels', textoFixo: 'Nacionalidade:' },
  { id: 'textoLivre1', label: 'Texto Livre 1', tipo: 'label', grupo: 'Labels', textoFixo: 'Texto personalizado' },
  { id: 'textoLivre2', label: 'Texto Livre 2', tipo: 'label', grupo: 'Labels', textoFixo: 'Texto personalizado' },
  { id: 'textoLivre3', label: 'Texto Livre 3', tipo: 'label', grupo: 'Labels', textoFixo: 'Texto personalizado' }
];

// Agrupar campos por categoria
const CAMPOS_AGRUPADOS = CAMPOS_DISPONIVEIS.reduce((acc, campo) => {
  if (!acc[campo.grupo]) acc[campo.grupo] = [];
  acc[campo.grupo].push(campo);
  return acc;
}, {});

// Fontes disponíveis
const FONTES_DISPONIVEIS = [
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Helvetica-Bold', label: 'Helvetica Bold' },
  { value: 'Helvetica-Oblique', label: 'Helvetica Itálico' },
  { value: 'Times-Roman', label: 'Times Roman' },
  { value: 'Times-Bold', label: 'Times Bold' },
  { value: 'Courier', label: 'Courier' },
  { value: 'Courier-Bold', label: 'Courier Bold' }
];

// Escala de visualização (o template original é 240x153)
const ESCALA = 2.5;
const CRED_WIDTH = 240;
const CRED_HEIGHT = 153;

const CredencialConfigPage = () => {
  const navigate = useNavigate();
  
  // Estados
  const [cursos, setCursos] = useState([]);
  const [cursoSelecionado, setCursoSelecionado] = useState('');
  const [config, setConfig] = useState(null);
  const [ladoAtivo, setLadoAtivo] = useState('frente');
  const [campoSelecionado, setCampoSelecionado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [templateUrl, setTemplateUrl] = useState({ frente: null, verso: null });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [isResizing, setIsResizing] = useState(false);
  const [grupoExpandido, setGrupoExpandido] = useState('Aluno');
  
  // Refs
  const canvasRef = useRef(null);
  const frenteInputRef = useRef(null);
  const versoInputRef = useRef(null);

  // Carregar lista de cursos
  useEffect(() => {
    carregarCursos();
  }, []);

  const carregarCursos = async () => {
    try {
      const response = await api.get('/cursos');
      const cursosData = response.data.data || [];
      
      const cursosFormatados = cursosData.map(curso => ({
        id: curso.idCurso,
        nome: curso.nome,
        sigla: curso.nome.toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]/g, '_')
      }));
      
      setCursos(cursosFormatados);
    } catch (error) {
      console.error('Erro ao carregar cursos:', error);
      setError('Erro ao carregar lista de cursos');
    }
  };

  // Carregar configuração quando curso for selecionado
  useEffect(() => {
    if (cursoSelecionado) {
      carregarConfiguracao();
    }
  }, [cursoSelecionado]);

  const carregarConfiguracao = async () => {
    setLoading(true);
    setError('');
    
    try {
      const response = await credencialConfigService.obterConfig(cursoSelecionado);
      setConfig(response.data.config);
      
      const baseUrl = api.defaults.baseURL;
      
      setTemplateUrl({
        frente: response.data.temFrente 
          ? `${baseUrl}/credencial-config/${cursoSelecionado}/template/frente?t=${Date.now()}` 
          : null,
        verso: response.data.temVerso 
          ? `${baseUrl}/credencial-config/${cursoSelecionado}/template/verso?t=${Date.now()}` 
          : null
      });
    } catch (error) {
      console.error('Erro ao carregar configuração:', error);
      await criarNovaConfiguracao();
    } finally {
      setLoading(false);
    }
  };

  const criarNovaConfiguracao = async () => {
    try {
      const response = await credencialConfigService.criarTemplate(cursoSelecionado);
      setConfig(response.data);
    } catch (error) {
      setError('Erro ao criar configuração padrão');
    }
  };

  // Obter campos do lado ativo
  const getCamposLadoAtivo = () => {
    if (!config?.credencial?.[ladoAtivo]?.campos) return {};
    return config.credencial[ladoAtivo].campos;
  };

  // Obter configuração de foto (apenas frente)
  const getFotoConfig = () => {
    if (ladoAtivo !== 'frente' || !config?.credencial?.frente?.foto) return null;
    return config.credencial.frente.foto;
  };

  // Atualizar posição de um campo
  const atualizarPosicaoCampo = (campoId, novasPosicoes) => {
    setConfig(prev => ({
      ...prev,
      credencial: {
        ...prev.credencial,
        [ladoAtivo]: {
          ...prev.credencial[ladoAtivo],
          campos: {
            ...prev.credencial[ladoAtivo].campos,
            [campoId]: {
              ...prev.credencial[ladoAtivo].campos[campoId],
              ...novasPosicoes
            }
          }
        }
      }
    }));
  };

  // Atualizar configuração de foto
  const atualizarFoto = (novasPosicoes) => {
    setConfig(prev => ({
      ...prev,
      credencial: {
        ...prev.credencial,
        frente: {
          ...prev.credencial.frente,
          foto: {
            ...prev.credencial.frente.foto,
            ...novasPosicoes
          }
        }
      }
    }));
  };

  // Adicionar novo campo
  const adicionarCampo = (campoId) => {
    const campos = getCamposLadoAtivo();
    if (campos[campoId]) {
      setError(`Campo "${campoId}" já existe neste lado`);
      setTimeout(() => setError(''), 3000);
      return;
    }

    const campoInfo = CAMPOS_DISPONIVEIS.find(c => c.id === campoId);

    setConfig(prev => ({
      ...prev,
      credencial: {
        ...prev.credencial,
        [ladoAtivo]: {
          ...prev.credencial[ladoAtivo],
          campos: {
            ...prev.credencial[ladoAtivo].campos,
            [campoId]: {
              x: 50,
              y: 50,
              fontSize: 9,
              font: 'Helvetica',
              color: '#000000',
              maxWidth: 100,
              height: 12,
              align: 'left',
              textoFixo: campoInfo?.textoFixo || null
            }
          }
        }
      }
    }));

    setCampoSelecionado(campoId);
    setSuccess(`Campo "${campoInfo?.label}" adicionado!`);
    setTimeout(() => setSuccess(''), 2000);
  };

  // Remover campo
  const removerCampo = (campoId) => {
    setConfig(prev => {
      const novosCampos = { ...prev.credencial[ladoAtivo].campos };
      delete novosCampos[campoId];
      
      return {
        ...prev,
        credencial: {
          ...prev.credencial,
          [ladoAtivo]: {
            ...prev.credencial[ladoAtivo],
            campos: novosCampos
          }
        }
      };
    });
    
    if (campoSelecionado === campoId) {
      setCampoSelecionado(null);
    }
  };

  // Handlers de drag
  const handleMouseDown = (e, tipo, id) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Verificar se é resize (clicou no canto inferior direito)
    const target = e.target;
    if (target.classList.contains('resize-handle')) {
      setIsResizing(true);
    } else {
      setIsDragging(true);
    }
    
    setCampoSelecionado(tipo === 'campo' ? id : 'foto');
    
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / ESCALA;
    const y = (e.clientY - rect.top) / ESCALA;
    
    let itemX, itemY;
    if (tipo === 'foto') {
      const foto = getFotoConfig();
      itemX = foto?.x || 0;
      itemY = foto?.y || 0;
    } else {
      const campo = getCamposLadoAtivo()[id];
      itemX = campo?.x || 0;
      itemY = campo?.y || 0;
    }
    
    setDragOffset({
      x: x - itemX,
      y: y - itemY,
      tipo,
      id,
      startX: x,
      startY: y
    });
  };

  const handleMouseMove = useCallback((e) => {
    if (!canvasRef.current) return;
    
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / ESCALA;
    const y = (e.clientY - rect.top) / ESCALA;
    
    if (isDragging) {
      let newX = x - dragOffset.x;
      let newY = y - dragOffset.y;
      
      // Limitar dentro da área da credencial
      newX = Math.max(0, Math.min(newX, CRED_WIDTH - 20));
      newY = Math.max(0, Math.min(newY, CRED_HEIGHT - 10));
      
      if (dragOffset.tipo === 'foto') {
        atualizarFoto({ x: Math.round(newX), y: Math.round(newY) });
      } else {
        atualizarPosicaoCampo(dragOffset.id, { x: Math.round(newX), y: Math.round(newY) });
      }
    } else if (isResizing) {
      // Calcular novo tamanho
      const campo = dragOffset.tipo === 'foto' ? getFotoConfig() : getCamposLadoAtivo()[dragOffset.id];
      if (campo) {
        const newWidth = Math.max(20, Math.round(x - campo.x));
        const newHeight = Math.max(8, Math.round(y - campo.y));
        
        if (dragOffset.tipo === 'foto') {
          atualizarFoto({ width: newWidth, height: newHeight });
        } else {
          atualizarPosicaoCampo(dragOffset.id, { maxWidth: newWidth, height: newHeight });
        }
      }
    }
  }, [isDragging, isResizing, dragOffset]);

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
    setIsResizing(false);
  }, []);

  // Event listeners para drag
  useEffect(() => {
    if (isDragging || isResizing) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    }
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, isResizing, handleMouseMove, handleMouseUp]);

  // Upload de template
  const handleUploadTemplate = async (lado, file) => {
    if (!file) return;
    
    try {
      setLoading(true);
      await credencialConfigService.uploadTemplate(cursoSelecionado, file, lado);
      
      setTemplateUrl(prev => ({
        ...prev,
        [lado]: `${api.defaults.baseURL}/credencial-config/${cursoSelecionado}/template/${lado}?t=${Date.now()}`
      }));
      
      setSuccess(`Template ${lado} enviado com sucesso!`);
    } catch (error) {
      setError(`Erro ao enviar template ${lado}`);
    } finally {
      setLoading(false);
    }
  };

  // Salvar configuração
  const handleSalvar = async () => {
    setSaving(true);
    setError('');
    setSuccess('');
    
    try {
      await credencialConfigService.salvarConfig(cursoSelecionado, config);
      setSuccess('Configuração salva com sucesso!');
    } catch (error) {
      setError('Erro ao salvar configuração');
    } finally {
      setSaving(false);
    }
  };

  // Renderizar campo arrastável
  const renderCampo = (campoId, configCampo) => {
    const campoInfo = CAMPOS_DISPONIVEIS.find(c => c.id === campoId);
    const label = campoInfo?.label || campoId;
    const isSelected = campoSelecionado === campoId;
    const isLabel = campoInfo?.tipo === 'label';
    
    // Texto de exibição: textoFixo, ou valor específico por curso, ou placeholder
    let displayText = configCampo.textoFixo || `[${label}]`;
    
    // Para curso de Capelania, mostrar texto fixo no campo Função
    if (campoId === 'funcao' && cursoSelecionado?.toLowerCase().includes('capelania')) {
      displayText = 'CAPELÃO EVANGÉLICO';
    }
    
    return (
      <div
        key={campoId}
        className={`absolute cursor-move select-none group ${
          isSelected ? 'z-20' : 'z-10'
        }`}
        style={{
          left: configCampo.x * ESCALA,
          top: configCampo.y * ESCALA,
          width: (configCampo.maxWidth || 100) * ESCALA,
          minHeight: (configCampo.height || 12) * ESCALA,
        }}
        onMouseDown={(e) => handleMouseDown(e, 'campo', campoId)}
        title={`${label}\nx: ${configCampo.x}, y: ${configCampo.y}\nLargura: ${configCampo.maxWidth || 100}, Altura: ${configCampo.height || 12}`}
      >
        {/* Área do texto */}
        <div
          className={`px-1 rounded whitespace-nowrap overflow-hidden ${
            isSelected 
              ? 'ring-2 ring-blue-500 bg-blue-100/70' 
              : 'hover:bg-yellow-100/50 border border-dashed border-gray-400/50'
          } ${isLabel ? 'italic' : ''}`}
          style={{
            fontSize: (configCampo.fontSize || 9) * ESCALA * 0.8,
            color: configCampo.color || '#000000',
            fontWeight: configCampo.font?.includes('Bold') ? 'bold' : 'normal',
            fontStyle: configCampo.font?.includes('Oblique') ? 'italic' : 'normal',
            fontFamily: configCampo.font?.includes('Courier') ? 'monospace' : 
                       configCampo.font?.includes('Times') ? 'serif' : 'sans-serif',
            textAlign: configCampo.align || 'left',
            minHeight: (configCampo.height || 12) * ESCALA
          }}
        >
          {displayText}
        </div>
        
        {/* Handle de resize (canto inferior direito) */}
        {isSelected && (
          <div
            className="resize-handle absolute bottom-0 right-0 w-3 h-3 bg-blue-500 cursor-se-resize rounded-sm"
            style={{ transform: 'translate(50%, 50%)' }}
          />
        )}
        
        {/* Indicador de arraste */}
        {isSelected && (
          <div className="absolute -left-5 top-1/2 -translate-y-1/2 text-blue-500">
            <FontAwesomeIcon icon={faGripVertical} size="sm" />
          </div>
        )}
      </div>
    );
  };

  // Renderizar área de foto
  const renderFoto = () => {
    const foto = getFotoConfig();
    if (!foto) return null;
    
    const isSelected = campoSelecionado === 'foto';
    
    return (
      <div
        className={`absolute cursor-move border-2 border-dashed flex items-center justify-center text-xs ${
          isSelected ? 'border-blue-500 bg-blue-100/30 z-20' : 'border-gray-400 bg-gray-100/30 z-10'
        }`}
        style={{
          left: foto.x * ESCALA,
          top: foto.y * ESCALA,
          width: foto.width * ESCALA,
          height: foto.height * ESCALA
        }}
        onMouseDown={(e) => handleMouseDown(e, 'foto', 'foto')}
        title={`Foto\nx: ${foto.x}, y: ${foto.y}\n${foto.width}x${foto.height}`}
      >
        <span className="text-gray-500">📷 FOTO</span>
        
        {/* Handle de resize */}
        {isSelected && (
          <div
            className="resize-handle absolute bottom-0 right-0 w-3 h-3 bg-blue-500 cursor-se-resize rounded-sm"
            style={{ transform: 'translate(50%, 50%)' }}
          />
        )}
      </div>
    );
  };

  // Obter campo atualmente selecionado
  const getCampoSelecionadoConfig = () => {
    if (!campoSelecionado || campoSelecionado === 'foto') return null;
    return getCamposLadoAtivo()[campoSelecionado];
  };

  const campoConfig = getCampoSelecionadoConfig();
  const campoInfo = campoSelecionado ? CAMPOS_DISPONIVEIS.find(c => c.id === campoSelecionado) : null;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        {/* Cabeçalho */}
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center">
            <button
              onClick={() => navigate(-1)}
              className="mr-4 text-gray-600 hover:text-gray-800"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="w-5 h-5" />
            </button>
            <div>
              <h1 className="text-3xl font-bold text-gray-800 flex items-center">
                <FontAwesomeIcon icon={faCog} className="mr-3 text-green-600" />
                Configuração de Credenciais
              </h1>
              <p className="text-gray-600 mt-1">
                Configure o posicionamento dos campos nas credenciais de cada curso
              </p>
            </div>
          </div>
          
          {cursoSelecionado && config && (
            <button
              onClick={handleSalvar}
              disabled={saving}
              className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 flex items-center font-medium"
            >
              <FontAwesomeIcon icon={saving ? faSpinner : faSave} className={`mr-2 ${saving ? 'animate-spin' : ''}`} />
              {saving ? 'Salvando...' : 'Salvar Configuração'}
            </button>
          )}
        </div>

        {/* Mensagens */}
        {error && (
          <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-800">
            {error}
            <button onClick={() => setError('')} className="ml-4 text-red-600 font-bold">×</button>
          </div>
        )}
        
        {success && (
          <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-800">
            {success}
            <button onClick={() => setSuccess('')} className="ml-4 text-green-600 font-bold">×</button>
          </div>
        )}

        {/* Seleção de Curso */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-lg font-semibold mb-4">Selecionar Curso</h2>
          <select
            value={cursoSelecionado}
            onChange={(e) => {
              setCursoSelecionado(e.target.value);
              setCampoSelecionado(null);
            }}
            className="w-full md:w-1/2 border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            <option value="">Selecione um curso...</option>
            {cursos.map(curso => (
              <option key={curso.id} value={curso.sigla}>
                {curso.nome}
              </option>
            ))}
          </select>
        </div>

        {loading && (
          <div className="flex justify-center items-center py-12">
            <FontAwesomeIcon icon={faSpinner} className="animate-spin w-8 h-8 text-green-600" />
          </div>
        )}

        {/* Editor de Credencial */}
        {cursoSelecionado && config && !loading && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Painel de Campos */}
            <div className="bg-white rounded-lg shadow-md p-6 max-h-[calc(100vh-200px)] overflow-y-auto">
              <h3 className="text-lg font-semibold mb-4">Campos Disponíveis</h3>
              
              {/* Campos agrupados por categoria */}
              <div className="space-y-2 mb-6">
                {Object.entries(CAMPOS_AGRUPADOS).map(([grupo, campos]) => (
                  <div key={grupo} className="border rounded">
                    <button
                      onClick={() => setGrupoExpandido(grupoExpandido === grupo ? null : grupo)}
                      className="w-full px-3 py-2 bg-gray-50 hover:bg-gray-100 flex justify-between items-center text-sm font-medium"
                    >
                      <span>{grupo}</span>
                      <span className="text-gray-400">
                        {grupoExpandido === grupo ? '▼' : '▶'}
                      </span>
                    </button>
                    
                    {grupoExpandido === grupo && (
                      <div className="p-2 grid grid-cols-2 gap-1">
                        {campos.map(campo => {
                          const jaExiste = getCamposLadoAtivo()[campo.id];
                          return (
                            <button
                              key={campo.id}
                              onClick={() => adicionarCampo(campo.id)}
                              disabled={jaExiste}
                              className={`text-xs px-2 py-1 rounded text-left truncate ${
                                jaExiste
                                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                  : 'bg-blue-50 hover:bg-blue-100 text-blue-700'
                              }`}
                              title={campo.label}
                            >
                              {jaExiste ? '✓' : '+'} {campo.label}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Lista de campos configurados */}
              <div className="border-t pt-4">
                <h4 className="text-sm font-medium text-gray-600 mb-2">
                  Campos no {ladoAtivo === 'frente' ? 'Frente' : 'Verso'}:
                </h4>
                <div className="space-y-1 max-h-40 overflow-y-auto">
                  {Object.entries(getCamposLadoAtivo()).map(([campoId, cfg]) => {
                    const info = CAMPOS_DISPONIVEIS.find(c => c.id === campoId);
                    return (
                      <div 
                        key={campoId}
                        className={`flex items-center justify-between p-2 rounded border text-sm ${
                          campoSelecionado === campoId ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:bg-gray-50'
                        }`}
                      >
                        <span 
                          className="cursor-pointer flex-1 truncate"
                          onClick={() => setCampoSelecionado(campoId)}
                        >
                          {info?.label || campoId}
                        </span>
                        <button
                          onClick={() => removerCampo(campoId)}
                          className="text-red-500 hover:text-red-700 p-1 ml-2"
                          title="Remover campo"
                        >
                          <FontAwesomeIcon icon={faTrash} size="sm" />
                        </button>
                      </div>
                    );
                  })}
                  {Object.keys(getCamposLadoAtivo()).length === 0 && (
                    <p className="text-gray-400 text-sm italic">Nenhum campo adicionado</p>
                  )}
                </div>
              </div>

              {/* Propriedades do campo selecionado */}
              {campoConfig && campoInfo && (
                <div className="mt-6 pt-4 border-t">
                  <h4 className="text-sm font-medium mb-3 flex items-center">
                    <FontAwesomeIcon icon={faCog} className="mr-2 text-gray-500" />
                    Propriedades: {campoInfo.label}
                  </h4>
                  <div className="space-y-3">
                    {/* Posição */}
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Posição X</label>
                        <input
                          type="number"
                          value={campoConfig.x || 0}
                          onChange={(e) => atualizarPosicaoCampo(campoSelecionado, { x: parseInt(e.target.value) || 0 })}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Posição Y</label>
                        <input
                          type="number"
                          value={campoConfig.y || 0}
                          onChange={(e) => atualizarPosicaoCampo(campoSelecionado, { y: parseInt(e.target.value) || 0 })}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                    </div>

                    {/* Tamanho */}
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">
                          <FontAwesomeIcon icon={faExpand} className="mr-1" />
                          Largura
                        </label>
                        <input
                          type="number"
                          value={campoConfig.maxWidth || 100}
                          onChange={(e) => atualizarPosicaoCampo(campoSelecionado, { maxWidth: parseInt(e.target.value) || 100 })}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Altura</label>
                        <input
                          type="number"
                          value={campoConfig.height || 12}
                          onChange={(e) => atualizarPosicaoCampo(campoSelecionado, { height: parseInt(e.target.value) || 12 })}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                    </div>

                    {/* Fonte */}
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">
                          <FontAwesomeIcon icon={faFont} className="mr-1" />
                          Tamanho Fonte
                        </label>
                        <input
                          type="number"
                          min="4"
                          max="24"
                          value={campoConfig.fontSize || 9}
                          onChange={(e) => atualizarPosicaoCampo(campoSelecionado, { fontSize: parseInt(e.target.value) || 9 })}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">
                          <FontAwesomeIcon icon={faPalette} className="mr-1" />
                          Cor
                        </label>
                        <div className="flex gap-1">
                          <input
                            type="color"
                            value={campoConfig.color || '#000000'}
                            onChange={(e) => atualizarPosicaoCampo(campoSelecionado, { color: e.target.value })}
                            className="w-10 h-8 border rounded cursor-pointer"
                          />
                          <input
                            type="text"
                            value={campoConfig.color || '#000000'}
                            onChange={(e) => atualizarPosicaoCampo(campoSelecionado, { color: e.target.value })}
                            className="flex-1 border rounded px-2 py-1 text-sm"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Tipo de Fonte */}
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Tipo de Fonte</label>
                      <select
                        value={campoConfig.font || 'Helvetica'}
                        onChange={(e) => atualizarPosicaoCampo(campoSelecionado, { font: e.target.value })}
                        className="w-full border rounded px-2 py-1 text-sm"
                      >
                        {FONTES_DISPONIVEIS.map(fonte => (
                          <option key={fonte.value} value={fonte.value}>
                            {fonte.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Alinhamento */}
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Alinhamento</label>
                      <div className="flex gap-1">
                        {['left', 'center', 'right'].map(align => (
                          <button
                            key={align}
                            onClick={() => atualizarPosicaoCampo(campoSelecionado, { align })}
                            className={`flex-1 py-1 px-2 text-xs rounded border ${
                              (campoConfig.align || 'left') === align
                                ? 'bg-blue-500 text-white border-blue-500'
                                : 'bg-white hover:bg-gray-100'
                            }`}
                          >
                            {align === 'left' ? '◀' : align === 'center' ? '◆' : '▶'}
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Texto Fixo (para labels) */}
                    {campoInfo.tipo === 'label' && (
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Texto</label>
                        <input
                          type="text"
                          value={campoConfig.textoFixo || ''}
                          onChange={(e) => atualizarPosicaoCampo(campoSelecionado, { textoFixo: e.target.value })}
                          className="w-full border rounded px-2 py-1 text-sm"
                          placeholder="Digite o texto..."
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Propriedades da foto */}
              {campoSelecionado === 'foto' && ladoAtivo === 'frente' && (
                <div className="mt-6 pt-4 border-t">
                  <h4 className="text-sm font-medium mb-3 flex items-center">
                    <FontAwesomeIcon icon={faCog} className="mr-2 text-gray-500" />
                    Propriedades da Foto
                  </h4>
                  <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Posição X</label>
                        <input
                          type="number"
                          value={getFotoConfig()?.x || 0}
                          onChange={(e) => atualizarFoto({ x: parseInt(e.target.value) || 0 })}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Posição Y</label>
                        <input
                          type="number"
                          value={getFotoConfig()?.y || 0}
                          onChange={(e) => atualizarFoto({ y: parseInt(e.target.value) || 0 })}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Largura</label>
                        <input
                          type="number"
                          value={getFotoConfig()?.width || 70}
                          onChange={(e) => atualizarFoto({ width: parseInt(e.target.value) || 70 })}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Altura</label>
                        <input
                          type="number"
                          value={getFotoConfig()?.height || 90}
                          onChange={(e) => atualizarFoto({ height: parseInt(e.target.value) || 90 })}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Área de Preview */}
            <div className="lg:col-span-2 bg-white rounded-lg shadow-md p-6">
              {/* Tabs Frente/Verso */}
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-2">
                  <button
                    onClick={() => { setLadoAtivo('frente'); setCampoSelecionado(null); }}
                    className={`px-4 py-2 rounded font-medium ${
                      ladoAtivo === 'frente' 
                        ? 'bg-green-600 text-white' 
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    Frente
                  </button>
                  <button
                    onClick={() => { setLadoAtivo('verso'); setCampoSelecionado(null); }}
                    className={`px-4 py-2 rounded font-medium ${
                      ladoAtivo === 'verso' 
                        ? 'bg-green-600 text-white' 
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                  >
                    Verso
                  </button>
                </div>

                {/* Upload de template */}
                <div className="flex gap-2">
                  <input
                    ref={frenteInputRef}
                    type="file"
                    accept="image/png,image/jpeg"
                    className="hidden"
                    onChange={(e) => handleUploadTemplate('frente', e.target.files[0])}
                  />
                  <input
                    ref={versoInputRef}
                    type="file"
                    accept="image/png,image/jpeg"
                    className="hidden"
                    onChange={(e) => handleUploadTemplate('verso', e.target.files[0])}
                  />
                  <button
                    onClick={() => ladoAtivo === 'frente' ? frenteInputRef.current?.click() : versoInputRef.current?.click()}
                    className="px-3 py-2 border rounded text-sm hover:bg-gray-100 flex items-center"
                  >
                    <FontAwesomeIcon icon={faUpload} className="mr-2" />
                    Upload Template {ladoAtivo === 'frente' ? 'Frente' : 'Verso'}
                  </button>
                </div>
              </div>

              {/* Canvas de Preview */}
              <div 
                className="flex justify-center overflow-auto bg-gray-100 rounded-lg p-4"
                onClick={() => setCampoSelecionado(null)}
              >
                <div
                  ref={canvasRef}
                  className="relative border-2 border-gray-300 bg-white shadow-lg"
                  style={{
                    width: CRED_WIDTH * ESCALA,
                    height: CRED_HEIGHT * ESCALA,
                    backgroundImage: templateUrl[ladoAtivo] ? `url(${templateUrl[ladoAtivo]})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Se não tem template, mostrar placeholder */}
                  {!templateUrl[ladoAtivo] && (
                    <div className="absolute inset-0 flex items-center justify-center text-gray-400">
                      <div className="text-center">
                        <FontAwesomeIcon icon={faIdCard} className="w-16 h-16 mb-2" />
                        <p>Faça upload do template {ladoAtivo}</p>
                      </div>
                    </div>
                  )}
                  
                  {/* Foto (apenas na frente) */}
                  {ladoAtivo === 'frente' && renderFoto()}
                  
                  {/* Campos */}
                  {Object.entries(getCamposLadoAtivo()).map(([campoId, cfg]) => 
                    renderCampo(campoId, cfg)
                  )}
                </div>
              </div>

              {/* Instruções */}
              <div className="mt-4 p-3 bg-blue-50 rounded-lg text-sm text-blue-800">
                <p className="font-medium mb-1">💡 Dicas de uso:</p>
                <ul className="list-disc list-inside space-y-1 text-xs">
                  <li><strong>Arrastar:</strong> Clique e arraste os campos para posicioná-los</li>
                  <li><strong>Redimensionar:</strong> Use o quadrado azul no canto para redimensionar</li>
                  <li><strong>Selecionar:</strong> Clique em um campo para editar suas propriedades</li>
                  <li><strong>Adicionar:</strong> Escolha campos dos grupos à esquerda</li>
                </ul>
              </div>
            </div>
          </div>
        )}

        {/* Estado inicial */}
        {!cursoSelecionado && !loading && (
          <div className="bg-white rounded-lg shadow-md p-12 text-center">
            <FontAwesomeIcon icon={faIdCard} className="w-16 h-16 text-gray-300 mb-4" />
            <p className="text-gray-600 text-lg">Selecione um curso para configurar as credenciais</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CredencialConfigPage;
